import React, { Component, createRef } from 'react';
export default class AgTableFloatingNotesFilter extends Component {

  render() {
    return (
      <div>
      </div>
    );
  }
}